const STATUS_COLORS = {
  draft: "outline-warning",
  awaiting_configuration: "outline-warning",
  scheduled: "outline-warning",
  live: "outline-success",
  completed: "outline-muted",
  cancel_hold: "outline-muted",
  canceled: "outline-muted",
  pending_approval: "outline-warning",
  pending_compliance_approval: "outline-warning",
  pending_network_audit: "outline-warning",
  pending_network_start: "outline-warning",
  pending_submission: "outline-warning",
  pending_creative_submission: "outline-warning",
  pending_extend: "outline-warning",
  pending_recurrence: "outline-warning",
  create_failed: "outline-danger",
  payment_failed: "outline-danger",
  compliance_rejected: "outline-danger",
  network_rejected: "outline-danger",
  submission_failed: "outline-danger"
};

const getCampaignStatusColor = (status, statusCategory) => {
  if (statusCategory === "action-required") return "outline-danger";
  if (STATUS_COLORS[status]) return STATUS_COLORS[status];
  return "outline-primary";
};

export { STATUS_COLORS };

export default getCampaignStatusColor;
